<template>
  <div class="maincen">
    <div class="inventory-box">
      <ul class="inventory-list">
        <li
          class="clearfix"
          v-for="(inventory, index) in lists"
          :key="index"
          @click="showDetail(inventory)"
        >
          <h1>{{ inventory.semesterStr }}</h1>
          <span class="time"
            ><a
              ><i>更新时间：</i>{{ inventory.createTime
              }} <i class="el-icon-arrow-right"></i> </a
          ></span>
          <span :class="statusText[inventory.statusCode][0]">{{
            statusText[inventory.statusCode][1]
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios.js'
import { selectSheetInfo } from '../../api/newslist/index.js'
export default {
  data() {
    return {
      lists: [],
      statusText: {
        0: ['reviewe-rough', '待提交'],
        1: ['reviewe-delay', '审核中'],
        2: ['reviewe-finish', '审核完成'],
      },
    }
  },
  created() {
    this.gitList()
  },
  methods: {
    showDetail(data) {
      this.$router.push({
        path: '/center/listDetail',
        query: { fid: data.semesterId },
      })
    },
    gitList() {
      selectSheetInfo()
        .then((res) => {
          if (res.status == 0) {
            this.lists = res.data
          }
        })
        .catch((error) => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 0px !important;
  min-height: 712px;
  padding:0 20px;
  background-color: white;
}
.inventory-box {
  width: 100%;
  margin-top:0px;
  padding: 30px 0px;
}
.inventory-list {
    // padding: 0px 30px 40px 30px;
  }
.inventory-list li {
  font-family: Microsoft YaHei;
  border-bottom: 1px dashed #e6e6e6;
  margin-top: 20px;
  line-height: 52px;
}

.inventory-list li h1 {
  width: 300px;
  float: left;
  overflow: hidden;
  font-size: 14px;
  line-height: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
  
  
}
.inventory-list li span {
  float: right;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 14px;
  margin-right: 100px;
}
.inventory-list li span.reviewe-delay {
  color: #FF9A2B;
}
.inventory-list li span.reviewe-finish {
  color: #0FBA9B;
}
.inventory-list li span.reviewe-rough {
  color: #999999;
}
.inventory-list li span.reviewe-lose {
  color: #0082F0;
}
.inventory-list li span.time a {
  
  text-decoration: none;
  outline: none;
  color: #999999;
}
.inventory-list li span.time {
  float: right;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  margin-right: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.inventory-list li span.time i {
  font-style: normal;
}
</style>
